import { Typography, List, Card } from 'antd';
import { BookOpen, Briefcase, GraduationCap } from 'lucide-react';

const { Title, Paragraph } = Typography;

const personas = [
    {
        key: 'students',
        icon: <GraduationCap size={32} />,
        title: "Ace Your Exams",
        description: "Capture lecture notes, summarize research papers, and organize study materials without leaving your browser.",
        points: [
            "Summarize long academic papers instantly with AI",
            "Keep research notes linked to the source URL",
            "Highlight and save key quotes from PDFs and websites"
        ]
    },
    {
        key: 'teachers',
        icon: <BookOpen size={32} />,
        title: "Plan Less, Teach More",
        description: "Curate lesson plans, save educational resources, and grade assignments with context-aware notes.",
        points: [
            "Build lesson plans directly on educational sites",
            "Save and organize teaching resources by topic",
            "Grade online submissions with side-by-side notes"
        ]
    },
    {
        key: 'corporate',
        icon: <Briefcase size={32} />,
        title: "Boost Team Productivity",
        description: "Streamline research, competitor analysis, and meeting notes. Secure, encrypted, and professional.",
        points: [
            "Competitor analysis with notes attached to their sites",
            "Securely share encrypted notes with team members",
            "Meeting agendas that stick to your calendar or video call tab"
        ]
    }
];

export default function UseCases() {
    return (
        <div className="section use-cases-section" id="use-cases">
            <div className="section-container">
                <div className="section-header">
                    <Title level={2}>Built for Everyone</Title>
                    <Paragraph className="section-subtitle">
                        Whether you are studying, teaching, or working, Page Notes adapts to your workflow.
                    </Paragraph>
                </div>

                <div className="use-case-grid">
                    {personas.map((persona) => (
                        <Card key={persona.key} className="use-case-card" bordered={false}>
                            <div className="use-case-icon-wrapper" style={{ color: '#818cf8', background: 'rgba(129, 140, 248, 0.1)', borderColor: 'rgba(129, 140, 248, 0.2)' }}>
                                {persona.icon}
                            </div>
                            <Title level={3} className="use-case-title">{persona.title}</Title>
                            <Paragraph className="use-case-description">
                                {persona.description}
                            </Paragraph>
                            <List
                                className="use-case-list"
                                dataSource={persona.points}
                                renderItem={(item) => (
                                    <List.Item>
                                        <span className="list-bullet">•</span> {item}
                                    </List.Item>
                                )}
                            />
                        </Card>
                    ))}
                </div>
            </div>
        </div>
    );
}
